import React from "react";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

// One line per earlier upload: when (as upload history shows it), what it produced, its status.
export const describePriorUpload = (upload) => {
    const when = upload.CreateDate ? moment(upload.CreateDate).format('MM/DD/YYYY h:mm A') : 'an earlier date';
    const jobs = upload.JobIds || [];
    const inbox = upload.InboxDocumentIds || [];
    const outcomes = [];
    if (jobs.length > 0) outcomes.push(`${jobs.length === 1 ? 'job' : 'jobs'} ${jobs.join(', ')}`);
    if (inbox.length > 0) outcomes.push(`Inbox ${inbox.length === 1 ? 'document' : 'documents'} ${inbox.join(', ')}`);
    if (outcomes.length === 0) outcomes.push('no job yet');
    return `This file was already uploaded on ${when} (${outcomes.join('; ')} / ${upload.Status || 'Unknown'}).`;
};

// "This file was already uploaded" (spec upload-reupload-warning.md). One decision for the batch:
// upload everything again, upload only the files not seen before, or send nothing.
const AlreadyUploadedDialog = ({ open, hits, hasNewFiles, onChoose }) => (
    <Dialog open={open} onClose={() => onChoose('cancel')} aria-labelledby="already-uploaded-title">
        <DialogTitle id="already-uploaded-title">{hits.length === 1 ? 'File already uploaded' : 'Files already uploaded'}</DialogTitle>
        <DialogContent>
            <DialogContentText>
                {hits.length === 1 ? 'This file was' : 'These files were'} already uploaded for this account in the last 30 days. Upload again?
            </DialogContentText>
            <ul aria-label="Already uploaded files">
                {hits.map(hit => (
                    <li key={hit.file.name}>
                        <strong>{hit.file.name}</strong>
                        <ul>
                            {hit.uploads.map(upload => <li key={upload.OcrDocumentId}>{describePriorUpload(upload)}</li>)}
                        </ul>
                    </li>
                ))}
            </ul>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => onChoose('cancel')} color="primary">Cancel</Button>
            {hasNewFiles && <Button onClick={() => onChoose('new')} color="primary">Upload only new files</Button>}
            <Button onClick={() => onChoose('all')} color="primary" variant="contained">Upload again</Button>
        </DialogActions>
    </Dialog>
);

export default AlreadyUploadedDialog;



// WEBPACK FOOTER //
// ./src/components/Common/CommonUpload/upload/AlreadyUploadedDialog.js